import { useState } from 'react';
import { PageLayout } from '../../../components/PageLayout';
import { useGetBooksQuery } from '../api/booksApi';
import { BookCard } from '../components/BookCard';
import { useGetPagination } from '../hooks/useGetPagination';
import { Helmet } from 'react-helmet';

export const Books = () => {
  const [page, setPage] = useState(1);

  const { data: books } = useGetBooksQuery({ page: page === 1 ? undefined : page });

  const { PaginationBar } = useGetPagination({
    count: books?.count,
    onPageChange: (page) => setPage(page),
    currentPage: page
  });

  return (
    <PageLayout title="Books">
      <Helmet>
        <title>SellBooks AI - Books</title>
      </Helmet>
      <div className="grid grid grid-cols-1 md:grid-cols-3 gap-3">
        {books?.results.map((book) => <BookCard key={book.id} book={book} />)}
      </div>
      {PaginationBar}
    </PageLayout>
  );
};
